<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import ItemCategory from "@/components/modals/item-category.vue";
import Unit from "@/components/modals/unit.vue";
import Office from "@/components/modals/delivery-unit.vue";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import XLSX from "xlsx";
import { saveAs } from "file-saver";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "Stocks"
  },
  components: {
    Layout,
    PageHeader,
    MaskedInput,
    ItemCategory,
    Unit,
    Office,
    UploadPopover,
    PrintOptions,
    RawData
  },
  data() {
    return {
      title: "Stocks",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Stocks",
          active: true
        }
      ],
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true
      }),
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      tableData: [],
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterTrans: "",
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        {
          key: "name",
          sortable: true,
          label: "Stocks"
        }
      ],
      fieldsTrans: [
        {
          key: "referenceNo",
          sortable: false,
          tdClass: "align-middle"
        },
        {
          key: "description",
          sortable: false,
          tdClass: "align-middle",
          thStyle: { width: "300px" }
        },
        {
          key: "quantity",
          sortable: false,
          tdClass: "align-middle",
          thStyle: { width: "350px" }
        },
        {
          key: "status",
          sortable: false,
          tdClass: "align-middle",
          thStyle: { width: "100px" }
        },
        {
          key: "actions",
          sortable: false,
          tdClass: "align-middle",
          thStyle: { width: "70px" }
        }
      ],
      form: {
        campusId: null,
        id: null,
        stockNumber: "",
        name: "",
        description: "",
        unitId: "",
        itemCategoryId: "",
        iarItemId: 0,
        subsidiaryLedgerId: 0
      },
      transForm: {
        stockItemId: null,
        description: "",
        debit: null,
        credit: null,
        unitCost: "",
        referenceNumber: "",
        iarItemId: null,
        deliveryUnitId: null,
        deliveryUnit: "",
        stockItemTransactionParentId: "",
        maxCredit: null
      },
      statusOptions: ["APPROVED", "PENDING"],
      tableBusy: false,
      editMode: false,
      unit: "",
      itemCategory: "",
      transaction: null,
      cycle: this.$store.state.data.cycle,
      campusId: this.$store.state.data.selectedCampus.id,
      isAdmin: this.$store.state.decrypt.isAdmin(),
      token: this.$store.state.decrypt.getToken(),
      uploadOptions: {
        type: "Transaction",
        placement: "lefttop",
        folder: "Stocks"
      },
      uploadType: "",
      selectedStock: null,
      selectedTransaction: null,
      debitCredit: 0,
      generateRIS: false,
      itemIndex: -1
    };
  },
  validations: {
    form: {
      stockNumber: { required },
      name: { required },
      unitId: { required },
      itemCategoryId: { required }
    }
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (item.name.toUpperCase().includes(this.filter.toUpperCase())) {
            return item.name.toUpperCase().includes(this.filter.toUpperCase());
          } else if (
            item.stockNumber.toUpperCase().includes(this.filter.toUpperCase())
          ) {
            return item.stockNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.description.toUpperCase().includes(this.filter.toUpperCase())
          ) {
            return item.description
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          }
        });
      }
      return data;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    }
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
  },
  methods: {
    changeCampus(data) {
      this.campusId = data.id;
      this.cycle = this.$store.state.data.cycle;
      this.getStock();
    },
    changeDU(data) {
      this.campusId = data.campusId;
      this.cycle = this.$store.state.data.cycle;
      this.getStock();
    },
    changeCycle(data) {
      this.campusId = this.$store.state.data.selectedCampus;
      this.getStock();
    },
    filteredTrans(row) {
      let data = row.transactions;
      if (row.filterPrice.trim() != "" && row.filterPrice) {
        let exactPrice = this.getExactAmt(row.filterPrice);
        data = data.filter((item) => {
          if (item.unitCost.toString() == exactPrice.toString()) {
            return item.unitCost.toString() == exactPrice.toString();
          }
        });
      }
      if (row.filter.trim() != "" && row.filter) {
        data = data.filter((item) => {
          if (
            item.referenceNumber
              .toUpperCase()
              .includes(row.filter.toUpperCase())
          ) {
            return item.referenceNumber
              .toUpperCase()
              .includes(row.filter.toUpperCase());
          } else if (
            item.description.toUpperCase().includes(row.filter.toUpperCase())
          ) {
            return item.description
              .toUpperCase()
              .includes(row.filter.toUpperCase());
          }
        });
      }
      return data;
    },
    rowsTrans(row) {
      if (row.filter.trim() != "" && row.filter) {
        return this.filteredTrans(row).length;
      } else {
        return row.transactions.length;
      }
    },
    getStock() {
      this.tableBusy = true;
      this.$store
        .dispatch("stock/GetStocks", this.campusId)
        .then((res) => {
          res.data.forEach((item) => {
            item.visible = false;
            item.currentPage = 1;
            item.perPage = 10;
            item.filter = "";
            item.filterPrice = "";
            item.transactionLoading = false;
            item.transactions = [];
          });
          this.tableData = res.data;
          this.tableBusy = false;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast("Something went wrong - Getting stock list!", "error");
        });
    },
    getTransactions(row) {
      row.visible = !row.visible;
      if (row.visible) {
        row.transactionLoading = true;
        setTimeout(() => {
          this.$store
            .dispatch("stock/GetStockTransactions", row.id)
            .then((res) => {
              res.data.forEach((item) => {
                item.stockFiles = [];
                item.viewFile = false;
                item.addDocu = false;
                item.attachmentLoading = false;
              });
              row.transactions = res.data.filter(
                (item) => item.status == null || item.status != "DRAFT"
              );
              row.transactionLoading = false;
            })
            .catch(() => {
              row.transactionLoading = false;
              this.showToast(
                "Something went wrong - Getting transactions!",
                "error"
              );
            });
        }, 400);
      } else {
        setTimeout(() => {
          row.transactions = [];
        }, 1000);
      }
    },
    getAvailableTransactions(row) {
      row.visible = !row.visible;
      if (row.visible) {
        row.transactionLoading = true;
        setTimeout(() => {
          this.$store
            .dispatch("stock/GetAvailableStockTransactions", row.id)
            .then((res) => {
              res.data.forEach((item) => {
                item.stockFiles = [];
                item.viewFile = false;
                item.addDocu = false;
                item.attachmentLoading = false;
                item.childTransactions = [];
                this.getChildTransactions(item);
              });
              row.transactions = res.data.sort((a, b) =>
                b.dateApproved.localeCompare(a.dateApproved)
              );
              row.transactionLoading = false;
            })
            .catch(() => {
              row.transactionLoading = false;
              this.showToast(
                "Something went wrong - Getting transactions!",
                "error"
              );
            });
        }, 400);
      } else {
        setTimeout(() => {
          row.transactions = [];
        }, 1000);
      }
    },
    getChildTransactions(row) {
      this.$store
        .dispatch("stock/GetChildStockTransactions", row.id)
        .then((res) => {
          res.data.forEach((item) => {
            item.stockFiles = [];
            item.viewFile = false;
            item.addDocu = false;
            item.attachmentLoading = false;
          });
          row.childTransactions = res.data.sort((a, b) =>
            b.dateApproved.localeCompare(a.dateApproved)
          );
        });
    },
    downloadExcelTemplate(type) {
      const s2ab = (s) => {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i < s.length; i++) {
          view[i] = s.charCodeAt(i) & 0xff;
        }
        return buf;
      };
      this.$swal({
        title: "Are you sure?",
        text: "You want to download the template?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, download it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          let wb = XLSX.utils.book_new();
          wb.Props = {
            Title:
              type == "stock" ? "Stock Template" : "Stock Transaction Template",
            Subject: "For Uploading",
            Author: "GIAMS Website",
            CreatedDate: new Date()
          };
          wb.SheetNames.push("Sheet 1");
          let ws_data =
            type == "stock"
              ? [
                  [
                    "StockNumber",
                    "Name",
                    "UnitId",
                    "ItemCategoryId",
                    "Description"
                  ]
                ]
              : type == "transaction debit"
              ? [["PoNumber", "Debit", "UnitCost", "Description"]]
              : [
                  [
                    "RisNumber",
                    "Credit",
                    "TransactionParentId",
                    "DeliveryUnitId",
                    "Description"
                  ]
                ];
          let ws = XLSX.utils.aoa_to_sheet(ws_data);
          wb.Sheets["Sheet 1"] = ws;

          let wbout = XLSX.write(wb, {
            bookType: "xlsx",
            type: "binary"
          });
          if (type == "stock") {
            saveAs(
              new Blob([s2ab(wbout)], {
                type: "application/octet-stream"
              }),
              "Stock_Template.xlsx"
            );
          } else if (type == "transaction debit") {
            saveAs(
              new Blob([s2ab(wbout)], {
                type: "application/octet-stream"
              }),
              "Stock_Debit_Template.xlsx"
            );
          } else if (type == "transaction credit") {
            saveAs(
              new Blob([s2ab(wbout)], {
                type: "application/octet-stream"
              }),
              "Stock_Credit_Template.xlsx"
            );
          }
        }
      });
    },
    uploadStock(type, stock, transaction) {
      this.selectedStock = stock ? stock : null;
      this.selectedTransaction = transaction ? transaction : null;
      this.uploadType = type;
      this.$bvModal.show("modal-excel");
    },
    renderExcel(event) {
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws);
          const excellist = [];
          for (var i = 0; i < data.length; i++) {
            excellist.push(data[i]);
          }
          this.excelList = excellist;
        };
        reader.readAsBinaryString(this.file);
      }
    },
    uploadExcel() {
      if (this.uploadType == "stock") {
        this.uploadExcelStock();
      } else {
        this.uploadExcelTransaction();
      }
    },
    uploadExcelStock() {
      var errorLabel = false;
      var errorData = false;
      var errorRow = null;
      this.errorData = "";
      var uploadArray = [];
      if (this.excelList.length == 0) {
        this.showToast("No data to upload!", "warning");
        return;
      }
      try {
        this.excelList.forEach((item) => {
          // Break Loop if Data is Invalid
          if (errorLabel || errorData) return;

          // Check Label
          errorLabel = this.checkExcelStockLabel(Object.keys(item));

          // Check Data
          errorRow = item;
          errorData = this.checkExcelStockData(item);

          // Set Value
          uploadArray.push({
            stockNumber: item.StockNumber
              ? item.StockNumber.toString().trim()
              : "Not Indicated",
            name: item.Name ? item.Name.toString().trim() : "Not Indicated",
            unitId: item.UnitId ? item.UnitId.toString().trim() : 0,
            itemCategoryId: item.ItemCategoryId
              ? item.ItemCategoryId.toString().trim()
              : 0,
            description: item.Description
              ? item.Description.toString().trim()
              : ""
          });
        });

        // Break Try
        if (errorLabel || errorData) return;

        // Upload File
        uploadArray.campusId = this.campusId;
        this.$store
          .dispatch("stock/CreateMultipleStock", uploadArray)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.getStock();
            this.$bvModal.hide("modal-excel");
            this.showToast("Successfully uploaded!", "success");
          })
          .catch(() => {
            this.showToast(
              "Something went wrong - Uploading excel data!",
              "error"
            );
          });
      } catch (error) {
        this.tableBusy = false;
        this.showPermanentToast(
          `"${this.errorData}" from the "${errorRow.__rowNum__}${
            errorRow.__rowNum__ == 1
              ? "st"
              : errorRow.__rowNum__ == 2
              ? "nd"
              : errorRow.__rowNum__ == 3
              ? "rd"
              : "th"
          } item" of the uploaded excel file is missing / does not match the proper format.`,
          "warning"
        );
      } finally {
        this.tableBusy = false;
        if (errorLabel) {
          this.showPermanentToast(
            `The "label" from the uploaded excel file is missing / does not match the proper format.`,
            "warning"
          );
        } else if (errorData) {
          this.showPermanentToast(
            `"${this.errorData}" from the "${errorRow.__rowNum__}${
              errorRow.__rowNum__ == 1
                ? "st"
                : errorRow.__rowNum__ == 2
                ? "nd"
                : errorRow.__rowNum__ == 3
                ? "rd"
                : "th"
            } item" of the uploaded excel file is missing / does not match the proper format.`,
            "warning"
          );
        }
      }
    },
    checkExcelStockLabel(row) {
      var labels = [
        "StockNumber",
        "Name",
        "UnitId",
        "ItemCategoryId",
        "Description"
      ];
      var error = row.filter((f) => !labels.includes(f));
      if (error.length > 0) return true;
      else return false;
    },
    checkExcelStockData(row) {
      var error = false;
      this.errorData = "";
      if (!row.StockNumber || row.StockNumber.toString().trim() == "") {
        if (this.errorData == "") {
          this.errorData = "StockNumber";
        } else {
          this.errorData = this.errorData
            .toString()
            .concat(", ", "StockNumber");
        }
        error = true;
      }
      if (!row.Name || row.Name.toString().trim() == "") {
        if (this.errorData == "") {
          this.errorData = "Name";
        } else {
          this.errorData = this.errorData.toString().concat(", ", "Name");
        }
        error = true;
      }
      if (!row.UnitId || row.UnitId.toString().trim() == "") {
        if (this.errorData == "") {
          this.errorData = "UnitId";
        } else {
          this.errorData = this.errorData.toString().concat(", ", "UnitId");
        }
        error = true;
      }
      if (!row.ItemCategoryId || row.ItemCategoryId.toString().trim() == "") {
        if (this.errorData == "") {
          this.errorData = "ItemCategoryId";
        } else {
          this.errorData = this.errorData
            .toString()
            .concat(", ", "ItemCategoryId");
        }
        error = true;
      }
      return error;
    },
    uploadExcelTransaction() {
      var errorLabel = false;
      var errorData = false;
      var errorRow = null;
      this.errorData = "";
      var uploadArray = [];
      if (this.excelList.length == 0) {
        this.showToast("No data to upload!", "warning");
        return;
      }
      try {
        this.excelList.forEach((item) => {
          // Break Loop if Data is Invalid
          if (errorLabel || errorData) return;

          // Check Label
          errorLabel = this.checkExcelTransactionLabel(Object.keys(item));

          // Check Data
          errorRow = item;
          errorData = this.checkExcelTransactionData(item);

          // Set Value
          if (this.uploadType == "transaction debit") {
            uploadArray.push({
              stockItemId: this.selectedStock.id,
              iarItemId: 0,
              status: "POSTED",
              referenceNumber: item.PoNumber
                ? item.PoNumber.toString().trim()
                : "Not Indicated",
              debit: item.Debit ? item.Debit.toString().trim() : "0",
              credit: "0",
              stockItemTransactionParentId: 0,
              deliveryUnitId: 0,
              unitCost: item.UnitCost ? item.UnitCost.toString().trim() : "0",
              description: item.Description
                ? item.Description.toString().trim()
                : ""
            });
          } else if (this.uploadType == "transaction credit") {
            uploadArray.push({
              stockItemId: this.selectedStock.id,
              iarItemId: 0,
              status: "POSTED",
              referenceNumber: item.RisNumber
                ? item.RisNumber.toString().trim()
                : "Not Indicated",
              debit: "0",
              credit: item.Credit ? item.Credit.toString().trim() : "0",
              stockItemTransactionParentId: item.TransactionParentId
                ? item.TransactionParentId.toString().trim()
                : 0,
              deliveryUnitId: item.DeliveryUnitId
                ? item.DeliveryUnitId.toString().trim()
                : 0,
              unitCost: this.selectedTransaction
                ? this.selectedTransaction.unitCost
                : "0",
              description: item.Description
                ? item.Description.toString().trim()
                : ""
            });
          }
        });

        // Break Try
        if (errorLabel || errorData) return;

        // Upload File
        this.$store
          .dispatch("stock/CreateMultipleStockTransaction", uploadArray)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.selectedStock.transactionLoading = true;
            setTimeout(() => {
              this.$store
                .dispatch(
                  "stock/GetAvailableStockTransactions",
                  this.selectedStock.id
                )
                .then((res) => {
                  res.data.forEach((item) => {
                    item.stockFiles = [];
                    item.viewFile = false;
                    item.addDocu = false;
                    item.attachmentLoading = false;
                    item.childTransactions = [];
                    this.getChildTransactions(item);
                  });
                  this.selectedStock.transactions = res.data.sort((a, b) =>
                    b.dateApproved.localeCompare(a.dateApproved)
                  );
                  this.selectedStock.transactionLoading = false;
                });
            }, 400);
            this.$bvModal.hide("modal-excel");
            this.showToast("Successfully uploaded!", "success");
          })
          .catch(() => {
            this.showToast(
              "Something went wrong - Uploading excel data!",
              "error"
            );
          });
      } catch (error) {
        this.tableBusy = false;
        this.showPermanentToast(
          `"${this.errorData}" from the "${errorRow.__rowNum__}${
            errorRow.__rowNum__ == 1
              ? "st"
              : errorRow.__rowNum__ == 2
              ? "nd"
              : errorRow.__rowNum__ == 3
              ? "rd"
              : "th"
          } item" of the uploaded excel file is missing / does not match the proper format.`,
          "warning"
        );
      } finally {
        this.tableBusy = false;
        if (errorLabel) {
          this.showPermanentToast(
            `The "label" from the uploaded excel file is missing / does not match the proper format.`,
            "warning"
          );
        } else if (errorData) {
          this.showPermanentToast(
            `"${this.errorData}" from the "${errorRow.__rowNum__}${
              errorRow.__rowNum__ == 1
                ? "st"
                : errorRow.__rowNum__ == 2
                ? "nd"
                : errorRow.__rowNum__ == 3
                ? "rd"
                : "th"
            } item" of the uploaded excel file is missing / does not match the proper format.`,
            "warning"
          );
        }
      }
    },
    checkExcelTransactionLabel(row) {
      var labels =
        this.uploadType == "transaction debit"
          ? ["PoNumber", "Debit", "UnitCost", "Description"]
          : [
              "RisNumber",
              "Credit",
              "TransactionParentId",
              "DeliveryUnitId",
              "Description"
            ];
      var error = row.filter((f) => !labels.includes(f));
      if (error.length > 0) return true;
      else return false;
    },
    checkExcelTransactionData(row) {
      var error = false;
      this.errorData = "";
      if (this.uploadType == "transaction debit") {
        if (!row.PoNumber || row.PoNumber.toString().trim() == "") {
          if (this.errorData == "") {
            this.errorData = "PoNumber";
          } else {
            this.errorData = this.errorData.toString().concat(", ", "PoNumber");
          }
          error = true;
        }
        if (!row.Debit || row.Debit.toString().trim() == "") {
          if (this.errorData == "") {
            this.errorData = "Debit";
          } else {
            this.errorData = this.errorData.toString().concat(", ", "Debit");
          }
          error = true;
        }
        if (!row.UnitCost || row.UnitCost.toString().trim() == "") {
          if (this.errorData == "") {
            this.errorData = "UnitCost";
          } else {
            this.errorData = this.errorData.toString().concat(", ", "UnitCost");
          }
          error = true;
        }
      } else if (this.uploadType == "transaction credit") {
        if (!row.RisNumber || row.RisNumber.toString().trim() == "") {
          if (this.errorData == "") {
            this.errorData = "RisNumber";
          } else {
            this.errorData = this.errorData
              .toString()
              .concat(", ", "RisNumber");
          }
          error = true;
        }
        if (!row.Credit || row.Credit.toString().trim() == "") {
          if (this.errorData == "") {
            this.errorData = "Credit";
          } else {
            this.errorData = this.errorData.toString().concat(", ", "Credit");
          }
          error = true;
        }
        if (
          !row.TransactionParentId ||
          row.TransactionParentId.toString().trim() == ""
        ) {
          if (this.errorData == "") {
            this.errorData = "TransactionParentId";
          } else {
            this.errorData = this.errorData
              .toString()
              .concat(", ", "TransactionParentId");
          }
          error = true;
        }
        if (!row.DeliveryUnitId || row.DeliveryUnitId.toString().trim() == "") {
          if (this.errorData == "") {
            this.errorData = "DeliveryUnitId";
          } else {
            this.errorData = this.errorData
              .toString()
              .concat(", ", "DeliveryUnitId");
          }
          error = true;
        }
      }
      return error;
    },
    ExcelDateToJSDate(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);

      var fractional_day = serial - Math.floor(serial) + 0.0000001;

      var total_seconds = Math.floor(86400 * fractional_day);

      var seconds = total_seconds % 60;

      total_seconds -= seconds;

      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;

      return new Date(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds
      );
    },
    onCreate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        try {
          var data = cloneDeep(this.form);
          data.stockNumber = data.stockNumber.trim();
          data.iarItemId = 0;
          if (data.id > 0) {
            this.$store
              .dispatch("stock/UpdateStock", data)
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                this.tableData.splice(this.itemIndex, 1, this.form);
                this.showToast("Successfully updated!", "success");
                this.onReset();
                this.$bvModal.hide("modal-create");
              })
              .catch((err) => {
                this.showToast(
                  "Something went wrong - Updating this stock!",
                  "error"
                );
              });
          } else {
            data.status = "POSTED";
            this.$store
              .dispatch("stock/CreateStock", data)
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                res.data.visible = false;
                res.data.currentPage = 1;
                res.data.perPage = 10;
                res.data.filter = "";
                res.data.filterPrice = "";
                res.data.transactionLoading = false;
                res.data.transactions = [];
                this.tableData.push(res.data);
                this.showToast("Successfully created!", "success");
                this.onReset();
                this.$bvModal.hide("modal-create");
              })
              .catch((err) => {
                this.showToast(
                  "Something went wrong - Creating stock!",
                  "error"
                );
              });
          }
          this.submitted = false;
        } catch (error) {
          this.showToast("Something went wrong!", "error");
        }
      }
    },
    addStock() {
      this.onReset();
      this.form.campusId = this.campusId;
      this.modalTitle = "Create Stock";
      this.$bvModal.show("modal-create");
    },
    updateItem(props) {
      this.onReset();
      this.itemIndex = this.tableData.findIndex((item) => item.id == props.id);
      this.form = cloneDeep(props);
      this.form.subsidiaryLedgerId = this.form.subsidiaryLedgerId
        ? this.form.subsidiaryLedgerId
        : 0;
      this.itemCategory = props.itemCategory;
      this.modalTitle = "Update Stock";
      this.$bvModal.show("modal-create");
    },
    deleteItem(props) {
      this.itemIndex = this.tableData.findIndex((item) => item.id == props.id);
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("stock/DeleteStock", props.id)
            .then((res) => {
              this.tableData.splice(this.itemIndex, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    async onCreateTrans() {
      this.submitted = true;
      if (this.checkTransForm()) {
        return;
      } else {
        this.selectedStock.transactionLoading = true;
        var data = cloneDeep(this.transForm);
        if (this.debitCredit == 0) {
          data.credit = this.getExactAmt(data.credit);
        }
        if (this.debitCredit == 1) {
          data.debit = this.getExactAmt(data.debit);
          data.unitCost = this.getExactAmt(data.unitCost);
        }
        if (data.id > 0) {
          this.$store
            .dispatch("stock/UpdateStockTransaction", data)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var transIndex = -1;
              if (this.debitCredit == 0) {
                transIndex = this.selectedTransaction.childTransactions.findIndex(
                  (item) => item.id == data.id
                );
                this.selectedTransaction.childTransactions.splice(
                  transIndex,
                  1,
                  data
                );
                this.showToast("Successfully updated!", "success");
                this.onReset();
                this.$bvModal.hide("modal-transaction");
                this.selectedStock.transactionLoading = false;
              } else {
                data.available = data.debit;
                transIndex = this.selectedStock.transactions.findIndex(
                  (item) => item.id == data.id
                );
                this.selectedStock.transactions.splice(transIndex, 1, data);
                this.showToast("Successfully updated!", "success");
                this.onReset();
                this.$bvModal.hide("modal-transaction");
                this.selectedStock.transactionLoading = false;
              }
            })
            .catch((err) => {
              this.selectedStock.transactionLoading = false;
              this.showToast(
                "Something went wrong - Updating transaction!",
                "error"
              );
            });
        } else {
          if (this.debitCredit == 0 && this.generateRIS) {
            await this.$store
              .dispatch("stock/GenerateStockTransactionRISNumber", {
                cycle: this.cycle,
                campusId: this.campusId
              })
              .then((res) => {
                data.referenceNumber = res.data;
              });
          }
          await this.$store
            .dispatch("stock/CreateMultipleStockTransaction", [data])
            .then((res) => {
              console.log(res.data);
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.selectedStock.transactionLoading = true;
              setTimeout(() => {
                this.$store
                  .dispatch(
                    "stock/GetAvailableStockTransactions",
                    this.selectedStock.id
                  )
                  .then((res) => {
                    res.data.forEach((item) => {
                      item.stockFiles = [];
                      item.viewFile = false;
                      item.addDocu = false;
                      item.attachmentLoading = false;
                      item.childTransactions = [];
                      this.getChildTransactions(item);
                    });
                    this.selectedStock.transactions = res.data.sort((a, b) =>
                      b.dateApproved.localeCompare(a.dateApproved)
                    );
                    this.selectedStock.transactionLoading = false;
                  });
              }, 400);
              this.showToast("Successfully created!", "success");
              this.$bvModal.hide("modal-transaction");
              this.selectedStock.transactionLoading = false;
            })
            .catch((err) => {
              this.selectedStock.transactionLoading = false;
              this.showToast(
                "Something went wrong - creating transaction!",
                "error"
              );
            });
        }
        this.submitted = false;
      }
    },
    createTransaction(stock, trans) {
      this.onReset();
      this.debitCredit = trans ? 0 : 1;
      this.selectedStock = stock;
      this.selectedTransaction = trans ? trans : null;
      this.transForm.iarItemId = 0;
      this.transForm.debit = trans ? 0 : "";
      this.transForm.credit = trans ? "" : 0;
      this.transForm.stockItemId = stock.id;
      this.transForm.deliveryUnitId = trans ? null : 0;
      this.transForm.stockItemTransactionParentId = trans ? trans.id : 0;
      this.transForm.maxCredit = trans ? trans.available : 0;
      this.transForm.unitCost = trans ? trans.unitCost : "";
      this.modalTitle = "Create Transaction";
      this.$bvModal.show("modal-transaction");
    },
    updateTransaction(props, stock, transaction) {
      this.onReset();
      if (!props.credit) {
        this.debitCredit = 1;
        this.$store
          .dispatch("stock/GetSingleStockTransaction", props.id)
          .then((res) => {
            res.data.stockFiles = [];
            res.data.viewFile = false;
            res.data.addDocu = false;
            res.data.attachmentLoading = false;
            res.data.childTransactions = [];
            this.transForm = res.data;
            this.selectedStock = stock;
            this.selectedTransaction = null;
            this.transForm.debit = this.transForm.debit.toString();
            this.transForm.credit = this.transForm.credit.toString();
            this.transForm.unitCost = this.transForm.unitCost.toString();
            this.modalTitle = "Update Transaction";
            this.$bvModal.show("modal-transaction");
          });
      } else {
        this.debitCredit = 0;
        this.transForm = cloneDeep(props);
        this.selectedStock = stock;
        this.selectedTransaction = transaction;
        this.transForm.debit = this.transForm.debit.toString();
        this.transForm.credit = this.transForm.credit.toString();
        this.transForm.unitCost = this.transForm.unitCost.toString();
        this.modalTitle = "Update Transaction";
        this.$bvModal.show("modal-transaction");
      }
    },
    approveTransaction(props, stock) {
      this.transaction = stock;
      this.$swal({
        title: "Are you sure?",
        text: "You are about to post this transaction.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, approve it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("stock/ApproveStockTransaction", props.id)
            .then((res) => {
              var transIndex = this.transaction.transactions.findIndex(
                (item) => item.id == props.id
              );
              this.transaction.transactions[transIndex].status = "POSTED";
              this.transaction.transactions[
                transIndex
              ].dateApproved = new Date();
              this.showToast("Successfully Posted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be Posted!", "error");
            });
        }
      });
    },
    deleteTransaction(props, stock, transaction) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("stock/DeleteStockTransaction", props.id)
            .then((res) => {
              var transIndex = -1;
              if (!transaction) {
                this.selectedStock = stock;
                transIndex = this.selectedStock.transactions.findIndex(
                  (item) => item.id == props.id
                );
                this.selectedStock.transactions.splice(transIndex, 1);
                this.showToast("Successfully deleted", "success");
              } else {
                this.selectedTransaction = transaction;
                transIndex = this.selectedTransaction.childTransactions.findIndex(
                  (item) => item.id == props.id
                );
                this.selectedTransaction.childTransactions.splice(
                  transIndex,
                  1
                );
                this.showToast("Successfully deleted", "success");
              }
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    checkTransForm() {
      if (this.debitCredit == 0) {
        if (
          this.transForm.credit === "" ||
          this.transForm.credit === null ||
          this.transForm.deliveryUnitId === "" ||
          this.transForm.deliveryUnitId === null
        ) {
          return true;
        } else return false;
      } else if (this.debitCredit == 1) {
        if (
          this.transForm.referenceNumber === "" ||
          this.transForm.referenceNumber === null ||
          this.transForm.debit === "" ||
          this.transForm.debit === null ||
          this.transForm.unitCost === "" ||
          this.transForm.unitCost === null
        ) {
          return true;
        } else return false;
      }
    },
    runningBalance(data) {
      let balance = 0;
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].status == "POSTED") {
            balance += data[i].debit - data[i].credit;
          }
        }
      }
      return balance;
    },
    indexBalance(index, data) {
      let balance = 0;
      if (data) {
        let reverseIndex = data.length - (index + 1);
        for (let i = 0; i <= reverseIndex; i++) {
          if (data[i].status == "POSTED")
            balance += data[i].debit - data[i].credit;
        }
      }
      return balance;
    },
    checkCredit() {
      if (
        parseFloat(this.transForm.credit) > parseFloat(this.transForm.maxCredit)
      )
        this.transForm.credit = this.transForm.maxCredit.toString();
    },
    onReset() {
      this.form = {
        campusId: null,
        id: null,
        stockNumber: "",
        name: "",
        description: "",
        unit: "",
        itemCategoryId: "",
        iarItemId: 0,
        subsidiaryLedgerId: 0
      };
      this.transForm = {
        stockItemId: null,
        description: "",
        debit: "",
        credit: "",
        unitCost: "",
        referenceNumber: "",
        iarItemId: 0,
        deliveryUnitId: null,
        deliveryUnit: "",
        stockItemTransactionParentId: null,
        maxCredit: null
      };
      this.itemCategory = "";
      this.debitCredit = 0;
      this.generateRIS = false;
      this.itemIndex = -1;
      this.submitted = false;
    },
    async printRis(stockItemId) {
      var apiUrl = `api/Report/Inspection/RIS`;
      var routeVariables = [stockItemId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables
      });
      this.$bvModal.show("print-options-modal");
    },
    getItemCategory() {
      this.$refs.itemcategory.filterStockCategory();
      this.$bvModal.show("item-category-modal");
    },
    dropItemCat(data) {
      this.form.itemCategoryId = data.id;
      this.itemCategory = data.name;
    },
    getUnit() {
      this.$refs.unit.getData();
      this.$bvModal.show("unit-modal");
    },
    dropUnit(data) {
      this.form.unitId = data.id;
      this.unit = data.unitName;
    },
    getOffice() {
      this.$refs.office.getSingleData();
      this.$bvModal.show("office-modal");
    },
    dropOffice(data) {
      this.transForm.deliveryUnitId = data.id;
      this.transForm.deliveryUnit = data.name;
    },
    propertyNumberWidth(number) {
      if (number < 100) return "min-width: 35px";
      else if (number < 1000) return "min-width: 50px";
      else if (number < 10000) return "min-width: 60px";
      else return "min-width: 75px";
    },
    getAttachments(row) {
      row.viewFile = true;
      row.stockFiles = [];
      row.attachmentLoading = true;
      this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: this.uploadOptions.type
        })
        .then((res) => {
          row.attachmentLoading = false;
          row.stockFiles = res.data;
        })
        .catch(() => {
          row.attachmentLoading = false;
          this.showToast("Something went wrong! - getting documents", "error");
        });
    },
    openDocument(x) {
      this.readFile(x.id);
    },
    removeFile(id, transactionId) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let transactionIndex = this.transactions.transactions.findIndex(
                (item) => item.id == transactionId
              );
              let fileIndex = this.transactions.transactions[
                transactionIndex
              ].stockFiles.findIndex((item) => item.id == id);
              this.transactions.transactions[
                transactionIndex
              ].stockFiles.splice(fileIndex, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    uploadedFiles() {}
  }
};
</script>

<template>
  <Layout
    @changeCampus="changeCampus"
    @changeDU="changeDU"
    @changeCycle="changeCycle"
  >
    <PageHeader :title="title" :items="items" />
    <!-- Create/Update Stock -->
    <b-modal
      id="modal-create"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="onCreate" class="needs-validation" ref="fcForm">
        <div class="mb-3">
          <label for="stockNumber">Stock Number </label>
          <input
            id="stockNumber"
            type="text"
            v-model="form.stockNumber"
            placeholder="Enter Stock Number..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.stockNumber.$error
            }"
            autocomplete="off"
          />
          <div
            v-if="submitted && $v.form.stockNumber.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.stockNumber.required"
              >This value is required.</span
            >
          </div>
        </div>
        <div class="mb-3">
          <label for="stockName">Stock Name </label>
          <input
            id="stockName"
            type="text"
            v-model="form.name"
            placeholder="Enter Stock Name..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.name.$error
            }"
            autocomplete="off"
          />
          <div v-if="submitted && $v.form.name.$error" class="invalid-feedback">
            <span v-if="!$v.form.name.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="unit">Unit </label>
          <b-input-group>
            <template #append>
              <b-button @click="getUnit()" variant="outline-info"
                ><i class="mdi mdi-clipboard-text-search-outline"></i
              ></b-button>
            </template>
            <input
              autocomplete="off"
              type="text"
              disabled
              placeholder="Search Unit..."
              class="form-control"
              :class="{
                'is-invalid': submitted && $v.form.unitId.$error
              }"
              v-model="unit"
            />
          </b-input-group>
          <div
            v-if="submitted && $v.form.unitId.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.unitId.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="itemCategoryId">Item Category </label>
          <b-input-group>
            <template #append>
              <b-button @click="getItemCategory" variant="outline-info"
                ><i class="mdi mdi-clipboard-text-search-outline"></i
              ></b-button>
            </template>
            <input
              autocomplete="off"
              type="text"
              disabled
              placeholder="Search Item Category..."
              class="form-control"
              :class="{
                'is-invalid': submitted && $v.form.itemCategoryId.$error
              }"
              v-model="itemCategory"
            />
          </b-input-group>
          <div
            v-if="submitted && $v.form.itemCategoryId.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.itemCategoryId.required"
              >This value is required.</span
            >
          </div>
        </div>
        <div class="mb-3">
          <label for="description">Stock Description </label>
          <textarea
            id="description"
            rows="6"
            v-model="form.description"
            placeholder="Enter Stock Description..."
            class="form-control"
            autocomplete="off"
          ></textarea>
        </div>

        <div class="d-flex flex-row-reverse mb-3">
          <button class="btn btn-primary mt-3" type="submit">
            {{ !(form.id > 0) > 0 ? "Create New Stock" : "Update Stock" }}
          </button>
        </div>
      </form>
    </b-modal>
    <!-- Create/Update Transaction -->
    <b-modal
      id="modal-transaction"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form
        @submit.prevent="onCreateTrans"
        class="needs-validation"
        ref="fcForm"
      >
        <div v-if="debitCredit == 1">
          <div class="mb-3">
            <label for="referenceNumber">P.O. Number </label>
            <input
              id="referenceNumber"
              type="text"
              v-model="transForm.referenceNumber"
              placeholder="Enter P.O. Number..."
              class="form-control"
              :class="{
                'is-invalid': submitted && transForm.referenceNumber == ''
              }"
              autocomplete="off"
            />
            <div
              v-if="submitted && transForm.referenceNumber == ''"
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
          <div class="mb-3">
            <label for="debit">Debit </label>
            <masked-input
              id="debit"
              type="text"
              v-model="transForm.debit"
              placeholder="Enter Debit..."
              class="form-control"
              :class="{
                'is-invalid':
                  submitted &&
                  (transForm.debit == null || transForm.debit == '')
              }"
              autocomplete="off"
              :mask="quantityMask"
            ></masked-input>
            <div
              v-if="
                submitted && (transForm.debit == null || transForm.debit == '')
              "
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
          <div class="mb-3">
            <label for="unitCost">Unit Cost </label>
            <masked-input
              id="unitCost"
              type="text"
              v-model="transForm.unitCost"
              placeholder="Enter Unit Cost..."
              class="form-control"
              :class="{
                'is-invalid':
                  submitted &&
                  (transForm.unitCost == null || transForm.unitCost == '')
              }"
              autocomplete="off"
              :mask="currencyMask"
            ></masked-input>
            <div
              v-if="
                submitted &&
                  (transForm.unitCost == null || transForm.unitCost == '')
              "
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
        </div>
        <div v-if="debitCredit == 0">
          <div v-if="!transForm.id" class="mb-3">
            <div class="form-check form-checkbox-outline form-check-success">
              <input
                type="checkbox"
                id="autoGenerate"
                checked="checked"
                class="form-check-input"
                v-model="generateRIS"
              /><label for="autoGenerate" class="form-check-label">
                Auto Generate RIS Number
              </label>
            </div>
          </div>
          <div v-if="!generateRIS" class="mb-3">
            <label for="referenceNumber">RIS Number </label>
            <input
              id="referenceNumber"
              type="text"
              v-model="transForm.referenceNumber"
              placeholder="Enter RIS Number..."
              class="form-control"
              :class="{
                'is-invalid': submitted && transForm.referenceNumber == ''
              }"
              autocomplete="off"
            />
            <div
              v-if="submitted && transForm.referenceNumber == ''"
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
          <div class="mb-3">
            <label for="credit"
              ><div>Credit</div>
              <small>Max Credit: {{ transForm.maxCredit }}</small></label
            >
            <masked-input
              id="credit"
              type="text"
              v-model="transForm.credit"
              placeholder="Enter Credit..."
              class="form-control"
              :class="{
                'is-invalid':
                  submitted &&
                  (transForm.credit == null || transForm.credit == '')
              }"
              autocomplete="off"
              :mask="quantityMask"
              @input="checkCredit()"
            ></masked-input>
            <div
              v-if="
                submitted &&
                  (transForm.credit == null || transForm.credit == '')
              "
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
          <div v-if="!transForm.id" class="mb-3">
            <label for="office">Office </label>
            <b-input-group>
              <template #append>
                <b-button @click="getOffice()" variant="outline-info"
                  ><i class="mdi mdi-clipboard-text-search-outline"></i
                ></b-button>
              </template>
              <input
                autocomplete="off"
                type="text"
                disabled
                placeholder="Search Office..."
                class="form-control"
                :class="{
                  'is-invalid':
                    submitted &&
                    (transForm.deliveryUnitId == null ||
                      transForm.deliveryUnitId == '')
                }"
                v-model="transForm.deliveryUnit"
              />
            </b-input-group>
            <div
              v-if="
                submitted &&
                  (transForm.deliveryUnitId == null ||
                    transForm.deliveryUnitId == '')
              "
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label for="description">Description </label>
          <textarea
            id="description"
            rows="6"
            v-model="transForm.description"
            placeholder="Enter Stock Description..."
            class="form-control"
            autocomplete="off"
          ></textarea>
        </div>

        <div class="d-flex flex-row-reverse mb-3">
          <button class="btn btn-primary mt-3" type="submit">
            {{ transForm.id > 0 ? "Update" : "Create" }}
          </button>
        </div>
      </form>
    </b-modal>
    <!-- Upload Excel -->
    <b-modal
      id="modal-excel"
      title="Upload Excel"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form class="needs-validation" ref="usForm">
        <div class="input-group">
          <input
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            class="form-control"
            id="inputGroupFile04"
            aria-describedby="inputGroupFileAddon04"
            aria-label="Upload"
            @change="renderExcel"
          />
        </div>
        <div class="d-flex flex-row-reverse">
          <button
            class="btn btn-primary mt-3"
            type="button"
            id="inputGroupFileAddon04"
            @click="uploadExcel"
          >
            Upload
          </button>
        </div>
      </form>
    </b-modal>
    <!-- Main -->
    <div
      class="card border-4 border-top border-start-0 border-end-0 border-primary"
    >
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="d-flex align-items-center h-100">
              <h5 class="mb-0 mt-2">List of Stocks</h5>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex align-items-center float-end">
              <button
                type="button"
                @click="addStock()"
                class="btn btn-sm btn-success d-flex align-items-center ms-1"
              >
                <i class="bx bx-plus fs-6 me-1"></i>Create Stock
              </button>
              <button
                type="button"
                @click="uploadStock('stock')"
                class="btn btn-sm btn-info d-flex align-items-center ms-1"
              >
                <i class="bx bx-upload fs-6 me-1"></i>Upload Stock
              </button>
              <button
                type="button"
                @click="downloadExcelTemplate('stock')"
                class="btn btn-sm btn-primary d-flex align-items-center ms-1"
              >
                <i class="bx bx-download fs-6 me-1"></i>Download Excel Template
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-md-6"></div>
          <div class="col-md-6">
            <div class="d-flex float-end">
              <div id="tickets-table_filter" class="dataTables_filter me-1">
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search Stocks..."
                    class="form-control"
                  ></b-form-input>
                </label>
              </div>
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center mb-0">
                  <b-form-select
                    class="form-select"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  >
                  </b-form-select>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="custom-table-responsive mb-0 mt-2">
          <b-table
            class="propertyTable datatables target-table"
            :items="filtered"
            :fields="fields"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            sort-by="name"
            :sort-desc="false"
            :busy="tableBusy"
            show-empty
            bordered
          >
            <template #empty>
              <b-card-header>
                <div class="text-center">
                  <div v-if="filter != ''">
                    <i class="fas fa-exclamation-triangle me-2"></i>There are no
                    stocks matching your request
                  </div>
                  <div v-else>
                    <i class="fas fa-exclamation-triangle me-2"></i>No stocks
                    available
                  </div>
                </div>
              </b-card-header>
            </template>
            <template #table-busy>
              <b-card-header>
                <div class="d-flex justify-content-center align-items-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </b-card-header>
            </template>
            <template #cell(name)="row">
              <div class="position-relative ms-1">
                <RawData
                  :data="row.item"
                  v-if="$store.state.decrypt.isAdmin()"
                />
              </div>
              <b-card-header header-tag="header" role="tab" class="border">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center pe-5">
                    <div class="text-muted">
                      <div class="font-size-11">
                        {{
                          row.item.stockNumber &&
                          row.item.stockNumber != "Not Indicated"
                            ? `Stock# ${row.item.stockNumber}`
                            : "Not Indicated"
                        }}
                      </div>
                      <h5 class="my-1 text-light">
                        {{ row.item.name }}
                      </h5>
                      <div class="font-size-11 d-flex align-items-center gap-2">
                        <span>
                          {{ row.item.itemCategory }}
                        </span>
                        |
                        <a
                          href="javascript: void(0);"
                          class="d-flex align-items-center"
                          @click="getAvailableTransactions(row.item)"
                        >
                          {{ row.item.visible ? "Hide" : "Show" }}
                          Details
                          <i
                            class="bx bx-chevron-right rotate font-size-14"
                            :class="{
                              'rotate-90': row.item.visible
                            }"
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center ms-5"
                  >
                    <i
                      class="bx bx-printer text-purple font-size-18 cursor-pointer ms-2"
                      :id="`stock-print-popover-${row.item.id}`"
                      tabindex="0"
                    ></i>
                    <b-popover
                      :target="`stock-print-popover-${row.item.id}`"
                      triggers="click blur"
                      placement="leftbottom"
                      variant="secondary"
                      custom-class="p-0"
                    >
                      <b-list-group class="w-100 fit">
                        <b-list-group-item
                          button
                          action
                          class="d-flex align-items-center"
                          ><i
                            class="bx bx-printer text-purple font-size-18 me-1"
                          ></i
                          >Print Stock Card</b-list-group-item
                        >
                      </b-list-group>
                    </b-popover>
                    <i
                      class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                      :id="`stock-popover-${row.item.id}`"
                      tabindex="0"
                    ></i>
                    <b-popover
                      :target="`stock-popover-${row.item.id}`"
                      triggers="click blur"
                      placement="leftbottom"
                      variant="secondary"
                      custom-class="p-0"
                    >
                      <b-list-group class="w-100 fit">
                        <b-list-group-item
                          button
                          action
                          class="d-flex align-items-center text-info"
                          @click="updateItem(row.item)"
                          ><i class="mdi mdi-update font-size-18 me-1"></i
                          >Update Stock</b-list-group-item
                        >
                        <b-list-group-item
                          button
                          action
                          class="d-flex align-items-center text-danger"
                          @click="deleteItem(row.item)"
                          ><i class="mdi mdi-trash-can font-size-18 me-1"></i
                          >Delete Stock</b-list-group-item
                        >
                      </b-list-group>
                    </b-popover>
                  </div>
                </div>
              </b-card-header>
              <b-collapse
                :visible="row.item.visible"
                role="tabpanel"
                class="p-0"
              >
                <b-card
                  class="shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0"
                >
                  <div class="d-flex justify-content-between mb-2">
                    <div class="d-flex align-items-center gap-1">
                      <b-form-input
                        autocomplete="off"
                        v-model="row.item.filter"
                        type="search"
                        placeholder="Search PO Number / Description..."
                        class="form-control form-control-sm"
                        style="width: 250px;"
                      ></b-form-input>
                      <masked-input
                        type="text"
                        v-model="row.item.filterPrice"
                        placeholder="Search Unit Cost..."
                        class="form-control form-control-sm"
                        autocomplete="off"
                        :mask="currencyMask"
                        style="width: 150px;"
                      ></masked-input>
                    </div>
                    <div class="d-flex align-items-center">
                      <button
                        type="button"
                        @click="createTransaction(row.item)"
                        class="btn btn-success btn-sm d-flex align-items-center ms-1"
                      >
                        <i class="bx bx-plus fs-6 me-1"></i>Create Debit
                      </button>
                      <button
                        type="button"
                        @click="uploadStock('transaction debit', row.item)"
                        class="btn btn-sm btn-info d-flex align-items-center ms-1"
                      >
                        <i class="bx bx-upload fs-6 me-1"></i>Upload Debit
                      </button>
                      <button
                        type="button"
                        @click="downloadExcelTemplate('transaction debit')"
                        class="btn btn-sm btn-primary d-flex align-items-center ms-1"
                      >
                        <i class="bx bx-download fs-6 me-1"></i>Download
                        Template
                      </button>
                    </div>
                  </div>
                  <div
                    class="border p-3 d-flex align-items-center justify-content-center"
                    v-if="row.item.transactionLoading"
                  >
                    <div class="preloader-component me-2">
                      <div class="status">
                        <div class="spinner-chase w-25px h-25px">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <h5 class="mb-0">Loading...</h5>
                  </div>
                  <div
                    class="text-center border p-3"
                    v-else-if="filteredTrans(row.item).length == 0"
                  >
                    <div>
                      <i class="fas fa-exclamation-triangle me-2"></i>No
                      Transactions available
                    </div>
                  </div>
                  <div
                    v-else
                    class="border border-start-0 border-end-0 pt-2"
                    style="max-height: 600px; overflow: auto"
                  >
                    <div
                      class="text-muted mb-2"
                      role="tablist"
                      v-for="(x, xIndex) in filteredTrans(row.item)"
                      :key="x.id"
                    >
                      <b-card
                        no-body
                        class="mb-0 border shadow-none"
                        :style="`z-index: ${xIndex + 1000}`"
                      >
                        <div class="position-relative ms-1">
                          <RawData
                            :data="x"
                            :keyId="`${row.item.id}-${x.id}`"
                            v-if="$store.state.decrypt.isAdmin()"
                          />
                        </div>
                        <b-card-header header-tag="header" role="tab">
                          <div
                            class="d-flex justify-content-between align-items-center"
                          >
                            <div>
                              <div class="d-flex align-items-center">
                                <small>PO No. {{ x.referenceNumber }}</small>
                                <div class="ms-2 me-2">
                                  |
                                </div>
                                <small>{{
                                  formatDate(new Date(x.dateApproved))
                                }}</small>
                              </div>
                              <div class="text-white">
                                <span class="text-info font-size-14">{{
                                  x.available
                                }}</span>
                                -
                                {{ formatCurrency(x.unitCost) }}
                                {{ row.item.name }} available.
                              </div>
                              <div>
                                {{ x.description }}
                              </div>
                            </div>
                            <div class="d-flex align-items-center">
                              <div>
                                <div>
                                  <span class="me-1">Attachments:</span>
                                  <a
                                    href="javascript:void(0);"
                                    @click="getAttachments(x)"
                                    :id="
                                      `approved-viewFiles-${row.item.id}-${x.id}`
                                    "
                                    >[Show attachments]</a
                                  >
                                  <b-popover
                                    :target="
                                      `approved-viewFiles-${row.item.id}-${x.id}`
                                    "
                                    triggers="click"
                                    placement="right"
                                    :show.sync="x.viewFile"
                                    custom-class="popover-supplier"
                                  >
                                    <template v-slot:title>
                                      <div
                                        class="d-flex align-items-center justify-content-between"
                                      >
                                        <small>Attachments</small>
                                        <span
                                          class="bx bx-x font-size-14 cursor-pointer"
                                          @click="x.viewFile = false"
                                        ></span>
                                      </div>
                                    </template>
                                    <table
                                      class="table table-bordered"
                                      v-if="
                                        !x.attachmentLoading &&
                                          x.stockFiles.length > 0
                                      "
                                    >
                                      <thead>
                                        <tr>
                                          <th>File Description</th>
                                          <th style="width: 30px"></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          v-for="attachments in x.stockFiles"
                                          :key="attachments.id"
                                        >
                                          <td
                                            @click="openDocument(y)"
                                            class="hoverable-link cursor-pointer"
                                          >
                                            <div>
                                              {{ attachments.description }}
                                            </div>
                                            <small>{{
                                              formatDateWithTime(
                                                new Date(
                                                  attachments.dateTimeUploaded
                                                )
                                              )
                                            }}</small>
                                          </td>
                                          <td>
                                            <i
                                              v-if="
                                                isAdmin ||
                                                  attachments.applicationUserId ==
                                                    token.ApplicationUserId
                                              "
                                              @click="
                                                removeFile(attachments.id, x.id)
                                              "
                                              class="cursor-pointer bx bx-trash text-danger"
                                            ></i>
                                            <i
                                              v-else
                                              class="bx bx-trash text-muted"
                                            ></i>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <div
                                      class="text-center"
                                      v-if="
                                        !x.attachmentLoading &&
                                          x.stockFiles.length == 0
                                      "
                                    >
                                      No data found
                                    </div>
                                    <div
                                      v-if="x.attachmentLoading"
                                      class="text-center"
                                    >
                                      <b-spinner
                                        variant="primary"
                                        label="Loading..."
                                      ></b-spinner>
                                    </div>
                                  </b-popover>
                                </div>
                                <div class="mt-1">
                                  <button
                                    :id="
                                      `approved-document-${row.item.id}-${x.id}`
                                    "
                                    type="button"
                                    class="btn btn-sm btn-outline-success"
                                    @click="x.addDocu = true"
                                  >
                                    <i class="bx bx-plus"></i>Add Attachments
                                  </button>
                                  <upload-popover
                                    :option="uploadOptions"
                                    :sourceId="x.id"
                                    @uploaded="uploadedFiles"
                                    :showPV="x.addDocu"
                                    @closePopover="x.addDocu = false"
                                    :dzId="
                                      `dropzone-approved-${row.item.id}-${x.id}`
                                    "
                                    :pvId="
                                      `approved-document-${row.item.id}-${x.id}`
                                    "
                                  ></upload-popover>
                                </div>
                              </div>
                              <div class="ms-5">
                                <i
                                  class="fas fa-ellipsis-v ps-2 pe-2 cursor-pointer text-white"
                                  :id="
                                    `stock-transaction-pending-popover-${row.item.id}-${x.id}`
                                  "
                                  tabindex="0"
                                ></i>
                                <b-popover
                                  :target="
                                    `stock-transaction-pending-popover-${row.item.id}-${x.id}`
                                  "
                                  triggers="click blur"
                                  placement="leftbottom"
                                  variant="secondary"
                                  custom-class="p-0"
                                >
                                  <b-list-group class="w-100 fit">
                                    <b-list-group-item
                                      v-if="
                                        x.childTransactions == null ||
                                          x.childTransactions.length == 0
                                      "
                                      button
                                      action
                                      class="d-flex align-items-center text-info"
                                      @click="updateTransaction(x, row.item)"
                                      ><i
                                        class="mdi mdi-update font-size-18 me-1"
                                      ></i
                                      >Update Debit</b-list-group-item
                                    >
                                    <b-list-group-item
                                      v-if="
                                        x.childTransactions == null ||
                                          x.childTransactions.length == 0
                                      "
                                      button
                                      action
                                      class="d-flex align-items-center text-danger"
                                      @click="deleteTransaction(x, row.item)"
                                      ><i
                                        class="mdi mdi-trash-can font-size-18 me-1"
                                      ></i
                                      >Delete Debit</b-list-group-item
                                    >
                                    <b-list-group-item
                                      button
                                      action
                                      class="d-flex align-items-center text-success"
                                      @click="createTransaction(row.item, x)"
                                      ><i
                                        class="bx bx-plus font-size-18 me-1"
                                      ></i
                                      >Create Credit</b-list-group-item
                                    >
                                    <b-list-group-item
                                      button
                                      action
                                      class="d-flex align-items-center text-info"
                                      @click="
                                        uploadStock(
                                          'transaction credit',
                                          row.item,
                                          x
                                        )
                                      "
                                      ><i
                                        class="bx bx-upload font-size-18 me-1"
                                      ></i
                                      >Upload Credit</b-list-group-item
                                    >
                                    <b-list-group-item
                                      button
                                      action
                                      class="d-flex align-items-center text-purple"
                                      @click="
                                        downloadExcelTemplate(
                                          'transaction credit'
                                        )
                                      "
                                      ><i
                                        class="bx bx-download font-size-18 me-1"
                                      ></i
                                      >Download Template</b-list-group-item
                                    >
                                  </b-list-group>
                                </b-popover>
                              </div>
                            </div>
                          </div>
                        </b-card-header>
                      </b-card>

                      <div
                        class="text-muted ms-4 mt-2"
                        role="tablist"
                        v-for="(y, yIndex) in x.childTransactions"
                        :key="y.id"
                      >
                        <b-card
                          no-body
                          class="mb-0 border shadow-none"
                          :style="`z-index: ${yIndex + 1000}`"
                        >
                          <div class="position-relative ms-1">
                            <RawData
                              :data="y"
                              :keyId="`${row.item.id}-${x.id}-${y.id}`"
                              v-if="$store.state.decrypt.isAdmin()"
                            />
                          </div>
                          <b-card-header header-tag="header" role="tab">
                            <div
                              class="d-flex justify-content-between align-items-center"
                            >
                              <div>
                                <div class="d-flex align-items-center">
                                  <small>RIS No. {{ y.referenceNumber }}</small>
                                  <div class="ms-2 me-2">
                                    |
                                  </div>
                                  <small>{{
                                    formatDate(new Date(y.dateApproved))
                                  }}</small>
                                </div>
                                <div class="text-white">
                                  <span class="text-warning font-size-14">{{
                                    y.credit
                                  }}</span>
                                  -
                                  {{ formatCurrency(y.unitCost) }}
                                  {{ row.item.name }} transferred to
                                  {{
                                    y.deliveryUnit
                                      ? y.deliveryUnit.name
                                      : "Not Indicated"
                                  }}.
                                </div>
                                <div>
                                  {{ y.description }}
                                </div>
                              </div>
                              <div class="d-flex align-items-center">
                                <div>
                                  <div>
                                    <span class="me-1">Attachments:</span>
                                    <a
                                      href="javascript:void(0);"
                                      @click="getAttachments(y)"
                                      :id="
                                        `approved-viewFiles-${row.item.id}-${x.id}-${y.id}`
                                      "
                                      >[Show attachments]</a
                                    >
                                    <b-popover
                                      :target="
                                        `approved-viewFiles-${row.item.id}-${x.id}-${y.id}`
                                      "
                                      triggers="click"
                                      placement="right"
                                      :show.sync="y.viewFile"
                                      custom-class="popover-supplier"
                                    >
                                      <template v-slot:title>
                                        <div
                                          class="d-flex align-items-center justify-content-between"
                                        >
                                          <small>Attachments</small>
                                          <span
                                            class="bx bx-x font-size-14 cursor-pointer"
                                            @click="y.viewFile = false"
                                          ></span>
                                        </div>
                                      </template>
                                      <table
                                        class="table table-bordered"
                                        v-if="
                                          !y.attachmentLoading &&
                                            y.stockFiles.length > 0
                                        "
                                      >
                                        <thead>
                                          <tr>
                                            <th>File Description</th>
                                            <th style="width: 30px"></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr
                                            v-for="attachments in y.stockFiles"
                                            :key="attachments.id"
                                          >
                                            <td
                                              @click="openDocument(y)"
                                              class="hoverable-link cursor-pointer"
                                            >
                                              <div>
                                                {{ attachments.description }}
                                              </div>
                                              <small>{{
                                                formatDateWithTime(
                                                  new Date(
                                                    attachments.dateTimeUploaded
                                                  )
                                                )
                                              }}</small>
                                            </td>
                                            <td>
                                              <i
                                                v-if="
                                                  isAdmin ||
                                                    attachments.applicationUserId ==
                                                      token.ApplicationUserId
                                                "
                                                @click="
                                                  removeFile(
                                                    attachments.id,
                                                    y.id
                                                  )
                                                "
                                                class="cursor-pointer bx bx-trash text-danger"
                                              ></i>
                                              <i
                                                v-else
                                                class="bx bx-trash text-muted"
                                              ></i>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <div
                                        class="text-center"
                                        v-if="
                                          !y.attachmentLoading &&
                                            y.stockFiles.length == 0
                                        "
                                      >
                                        No data found
                                      </div>
                                      <div
                                        v-if="y.attachmentLoading"
                                        class="text-center"
                                      >
                                        <b-spinner
                                          variant="primary"
                                          label="Loading..."
                                        ></b-spinner>
                                      </div>
                                    </b-popover>
                                  </div>
                                  <div class="mt-1">
                                    <button
                                      :id="
                                        `approved-document-${row.item.id}-${x.id}-${y.id}`
                                      "
                                      type="button"
                                      class="btn btn-sm btn-outline-success"
                                      @click="y.addDocu = true"
                                    >
                                      <i class="bx bx-plus"></i>Add Attachments
                                    </button>
                                    <upload-popover
                                      :option="uploadOptions"
                                      :sourceId="y.id"
                                      @uploaded="uploadedFiles"
                                      :showPV="y.addDocu"
                                      @closePopover="y.addDocu = false"
                                      :dzId="
                                        `dropzone-approved-${row.item.id}-${x.id}-${y.id}`
                                      "
                                      :pvId="
                                        `approved-document-${row.item.id}-${x.id}-${y.id}`
                                      "
                                    ></upload-popover>
                                  </div>
                                </div>
                                <div class="ms-5">
                                  <i
                                    class="fas fa-ellipsis-v ps-2 pe-2 cursor-pointer text-white"
                                    :id="
                                      `stock-transaction-pending-popover-${row.item.id}-${y.id}`
                                    "
                                    tabindex="0"
                                  ></i>
                                  <b-popover
                                    :target="
                                      `stock-transaction-pending-popover-${row.item.id}-${y.id}`
                                    "
                                    triggers="click blur"
                                    placement="leftbottom"
                                    variant="secondary"
                                    custom-class="p-0"
                                  >
                                    <b-list-group class="w-100 fit">
                                      <b-list-group-item
                                        button
                                        action
                                        class="d-flex align-items-center text-info"
                                        @click="
                                          updateTransaction(y, row.item, x)
                                        "
                                        ><i
                                          class="mdi mdi-update font-size-18 me-1"
                                        ></i
                                        >Update Credit</b-list-group-item
                                      >
                                      <b-list-group-item
                                        button
                                        action
                                        class="d-flex align-items-center text-danger"
                                        @click="
                                          deleteTransaction(y, row.item, x)
                                        "
                                        ><i
                                          class="mdi mdi-trash-can font-size-18 me-1"
                                        ></i
                                        >Delete Credit</b-list-group-item
                                      >
                                    </b-list-group>
                                  </b-popover>
                                </div>
                              </div>
                            </div>
                          </b-card-header>
                        </b-card>
                      </div>
                    </div>
                  </div>
                </b-card>
              </b-collapse>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div v-if="rows > 0" class="col">
            Showing {{ (currentPage - 1) * perPage + 1 }} -
            {{
              rows > (currentPage - 1) * perPage + perPage
                ? (currentPage - 1) * perPage + perPage
                : rows
            }}
            of {{ rows }}
          </div>
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul
                class="pagination pagination-rounded mb-0"
                style="z-index: -1"
              >
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <item-category
      ref="itemcategory"
      @dropData="dropItemCat($event)"
    ></item-category>
    <unit ref="unit" @dropData="dropUnit($event)"></unit>
    <Office ref="office" @dropData="dropOffice($event)"></Office>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.propertyTable tr td {
  padding: 0 !important;
  margin: 0 !important;
}

.transactionTable tr th {
  padding: 0 !important;
  margin: 0 !important;
}

.VueCarousel-slide-adjustableHeight {
  display: block !important;
}

.VueCarousel-inner {
  align-items: flex-start !important;
}

.fade-enter-active {
  animation: fade-in 0.5s;
}

.fade-leave-active {
  animation: fade-in 0.5s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
